import React from 'react';
import { LoginComponents } from '../../components';

type Props = {};

const Login = (props: Props) => {
  return (
    <div style={{ minHeight: '100%' }}>
      <div className="background-log">
        <div className="layout-login">
          <div className="position-login">
            <LoginComponents />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
